// Copy shared between the email-verification prompt flow and the account
// page's standalone add/update backup email modal

export const ADD_BACKUP_EMAIL_DESCRIPTION = 'A backup email address covers you if you ever lose access to your account email address.'

export const UPDATE_BACKUP_EMAIL_DESCRIPTION = "We'll send a code to your new email address to complete the update."

// backup email form validation errors
export const BACKUP_SAME_AS_ACCOUNT_EMAIL_ERROR = 'Your backup email address must not be the same as your account email address.'
export const BACKUP_SAME_AS_CURRENT_BACKUP_ERROR = 'Your new backup email address must not be the same as your current backup email address.'
